import {
  WHITE_BOARD_LIST_REQUEST,
  WHITE_BOARD_LIST_SUCCESS,
  WHITE_BOARD_LIST_FAILURE,
  RESET_STATE,
  WHITE_BOARD_BY_ID_REQUEST,
  WHITE_BOARD_BY_ID_SUCCESS,
  WHITE_BOARD_BY_ID_FAILURE,
} from "../constants/whiteBoard";

const initialState = {};

export function whiteBoardReducer(state = {}, action) {
  switch (action.type) {
    case WHITE_BOARD_LIST_REQUEST:
    case WHITE_BOARD_BY_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case WHITE_BOARD_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        whiteboardListData: action.payload,
      };
    case WHITE_BOARD_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        whiteboardByIdData: action.payload,
      };
    case WHITE_BOARD_LIST_FAILURE:
    case WHITE_BOARD_BY_ID_FAILURE:
      return {
        ...state,
        loading: true,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}
